import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const CartLegalTextWrapper = styled.div`
    font-size: ${getPurpurTypography('scale75')};
    line-height: 1.25rem;
    color: ${getPurpurColor('gray700')};
    padding: ${getPurpurSpacing('200')} 0;
`;
